import { useState, useEffect } from "react"
import { Box, Spinner, Text, Flex, Center } from "@chakra-ui/react"

export const BulkUploadLoader = () => {
	const [currentMessageIndex, setCurrentMessageIndex] = useState(0)
	const messages = [
		"Collecting your work orders...",
		"Processing work orders...",
		"Adding to system...",
		"Almost there...",
		"Finalizing upload...",
	]

	useEffect(() => {
		const interval = setInterval(() => {
			setCurrentMessageIndex((prevIndex) => {
				// Stop increasing when we reach the last index
				if (prevIndex === messages.length - 1) {
					clearInterval(interval)
					return prevIndex
				}
				return prevIndex + 1
			})
		}, 5000) // Change message every 5
		//  seconds

		return () => clearInterval(interval)
	}, [])

	return (
		<Flex direction="column" align="center" justify="center" h="16rem" w="full">
			<Center>
				{/* Chakra UI Spinner */}
				<Spinner
					thickness="4px"
					speed="0.65s"
					emptyColor="blue.100"
					color="blue.500"
					size="xl"
					mb={4}
				/>
			</Center>

			{/* Message that cycles */}
			<Box textAlign="center" mt={4} h="2rem">
				<Text color="gray.700" fontWeight="medium">
					{messages[currentMessageIndex]}
				</Text>
			</Box>
		</Flex>
	)
}
